import React from "react";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { Divider, DividerProps, IconProps, Tab, Tabs } from "@mui/material";

const dividerProps: DividerProps = {
  orientation: "vertical",
  sx: { width: "1px", height: "16px", bgcolor: "#DBE8F5", borderColor: "#DBE8F5" }
};

type ViewType = "tools" | "history" | "k1";

interface Props {
  value: ViewType;
  onChange: (value: ViewType) => void;
}

const iconsSx: IconProps["sx"] = {
  fontSize: "16px",
  mr: "6px"
};

export const Views: React.FC<Props> = ({ value, onChange }) => {
  return (
    <Tabs
      classes={{
        indicator: "indicator"
      }}
      TabIndicatorProps={{
        children: <span />
      }}
      sx={{
        minHeight: "24px",
        button: {
          p: 0,
          minHeight: "20px",
          fontWeight: "normal",
          color: "#5d7782",
          fontSize: "15px",
          minWidth: "auto"
        },
        ".MuiTabs-flexContainer": {
          alignItems: "center",
          gap: "15px"
        },
        "& .indicator": {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "transparent",
          "& > span": {
            width: "98%",
            backgroundColor: "#0a3142"
          }
        }
      }}
      value={value}
      onChange={(_: React.SyntheticEvent, newValue: ViewType) => onChange(newValue)}
    >
      <Tab
        label="Tools"
        icon={<FileDownloadOutlinedIcon sx={{ ...iconsSx, transform: "rotate(180deg)" }} />}
        value="tools"
        iconPosition="start"
      />
      <Divider {...dividerProps} />
      <Tab label="History" value="history" icon={<ListAltOutlinedIcon sx={{ ...iconsSx }} />} iconPosition="start" />
      <Divider {...dividerProps} />
      <Tab
        // disabled
        label="K1"
        value="k1"
        icon={<InsertDriveFileOutlinedIcon sx={{ ...iconsSx }} />}
        iconPosition="start"
      />
    </Tabs>
  );
};
